import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BlogComponent } from './blog/blog.component';
import { IndexComponent } from './index/index.component';
import { BlogEntryComponent } from './blog-entry/blog-entry.component';
import { LocationComponent } from './location/location.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ConditionsComponent } from './conditions/conditions.component';

const routes: Routes = [
  { path: 'blog', component: BlogComponent, data: { title: 'Blog' } },
  { path: 'blog/:blogId', component: BlogEntryComponent, data: { title: 'Blog Entry' } },
  { path: 'location/:userName', component: LocationComponent, data: { title: 'Location' } },
  { path: '', component: IndexComponent, data: { title: 'Home' } },
  { path: 'privacyPolicy', component: PrivacyPolicyComponent, data: { title: 'Pricacy Policy' } },
  { path: 'conditions', component: ConditionsComponent, data: { title: 'Terms & Conditions' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class HomeRoutingModule { }
